import styled from 'styled-components';

export const ForgotPasswordWrapperStyled = styled.div`
    .forgot-password-content__title {
        margin-bottom: 24px;
    }
    .forgot-password-content__email {
        margin-bottom: 24px;
        margin-top: 48px;
    }
    .forgot-password-content__buttons-panel {
        margin-top: 48px;
    }
`;
